import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import authService from '../services/api/authService';
import { useUser } from '../contexts/UserContext';
import Logo from './Logo';
import '../assets/styles/auth.css';
import showToast from '../utils/toastHelper';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const { login } = useUser();

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!navigator.onLine) {
      showToast('No internet connection. Please check your network.', 'error');
      return;
    }

    if (!email || !password) {
      showToast('Please enter both email and password', 'error');
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await authService.login({ email, password });
      const { token, user } = response.data;
      
      login(token, user);
      
      // Redirect based on user role
      if (user.role === 'super_admin') {
        navigate('/super-admin/dashboard');
      } else if (user.role === 'admin') {
        navigate('/admin/dashboard');
      } else {
        navigate('/dashboard');
      }
    } catch (err) {
      console.error('Login error:', err);
      const message = err.response?.data?.message || err.response?.data?.error || 'Login failed. Please try again.';
      showToast(message, 'error');
      setIsSubmitting(false);
    }
  };

  return (
    <div className="form-body-single">
      <div className="bg-shape bg-shape-1"></div>
      <div className="bg-shape bg-shape-2"></div>
      <div className="bg-shape bg-shape-3"></div>
      <div className="form-content-centered">
        <div style={{ marginBottom: '2rem' }}>
          <Logo color="white" width="300px" />
        </div>
        <div className="form-items">
          <h3 className="font-md">Sign-In</h3>
          <p>Sign in to participate in polls, campaigns, and cast your votes securely.</p>
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>
                Email Address
              </label>
              <input
                className="form-control"
                type="email"
                placeholder="Enter your email address"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group">
              <label>
                Password
                <Link to="/forgot-password" className="float-right">Forgot password?</Link>
              </label>
              <div style={{ position: 'relative' }}>
                <input
                  className="form-control"
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter your passcode"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={isSubmitting}
                  style={{ paddingRight: '2.5rem' }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#6b7280',
                    fontSize: '0.875rem',
                    padding: '0',
                    lineHeight: 1,
                  }}
                >
                  <i className={`bi bi-eye${showPassword ? '-slash' : ''}`}></i>
                </button>
              </div>
            </div>

            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
              {isSubmitting ? 'Signing in...' : 'Sign in'}
            </button>
          </form>
          
          <div className="page-links">
            <span>Don't have an account? </span>
            <Link to="/register">Create Account</Link>
          </div>
        </div>
      </div>

      <footer className="auth-footer">
        <div>© 2025. VoteWave.</div>
        <div>
          <Link to="/terms-and-conditions">Terms & Conditions</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>
      </footer>
    </div>
  );
};

export default Login;
